import PlanningManager from './PlanningManager'

export default function Orcamentos() {
  return <PlanningManager mode="orcamentos" />
}
